import ActivityPage from '@components/ActivityPage/PotentialCustomers'
import Introduce from '@components/LocalMerchant/SkyEyeSystem/PotentialCustomers/Introduce'
import { isUltimate } from '@merchant-backend/util'
import { asyncLoad } from '@util'

export default [
  {
    path: 'skyEyeSystem',
    indexRoute: {
      component: asyncLoad(() =>
        import('@components/LocalMerchant/SkyEyeSystem')
      ),
      onEnter(nextState, replaceState) {
        !isUltimate() && replaceState('localMerchant/SkyEyeSystem/introduce')
      }
    },
    stat: '天眼系统',
    childRoutes: [
      {
        path: 'introduce',
        indexRoute: {
          component: asyncLoad(() =>
            import('@components/LocalMerchant/SkyEyeSystem/Introduce')
          )
        },
        stat: '天眼系统营销页'
      },
      {
        path: 'potentialCustomers',
        indexRoute: {
          component: Introduce
        },
        stat: '潜在客资转化/使用说明',
        childRoutes: [
          {
            path: 'createPush',
            component: asyncLoad(() =>
              import('@components/LocalMerchant/SkyEyeSystem/PotentialCustomers/CreateBatchPush')
            ),
            stat: '天眼系统/潜在客资转化/新建推送'
          },
          {
            path: 'pushDetail/:id',
            component: asyncLoad(() =>
              import('@components/LocalMerchant/SkyEyeSystem/PotentialCustomers/PushDetail')
            ),
            stat: '天眼系统/潜在客资转化/推送详情'
          },
          {
            path: 'introduce',
            component: Introduce,
            stat: '天眼系统/潜在客资转化/使用说明'
          }
        ]
      },
      {
        path: 'potentialCustomersIntro',
        component: ActivityPage,
        stat: '潜在客资转化/宣传页'
      }
    ]
  }
]
